import { render } from "./AyudaAutenticadorMFA.vue?vue&type=template&id=2741594d&scoped=true"
import script from "./AyudaAutenticadorMFA.vue?vue&type=script&lang=js"
export * from "./AyudaAutenticadorMFA.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=2741594d&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2741594d"]])

export default __exports__